<template>
  <div class="full">
    <div class="full" id="earth_div">
      <!-- <div class="full abspos"> -->
        <!-- <pre v-if="debug">{{ Status.state }}</pre> -->
      <!-- </div> -->
    </div>
    <div v-if="earth">
      <MarkerLocale :key="mi" v-for="(mps, mi) in localeClusters"
        :markers="markers"
        :earth="earth"
        :cluster="mps"
        :open="mps[0].open"
      ></MarkerLocale>
    </div>

    <YoEarthLoader class="full" @ready="run">
    </YoEarthLoader>
  </div>
</template>

<script>
import { Status } from '../parts/YoNetwork/YoNetwork.js'
import * as eAPI from '../SubCompos/eAPI.js'
import _ from 'lodash'

export default {
  props: {
    earthID: {},
    // user owner of the earth
    userID: {}
  },
  components: {
    MarkerLocale: require('./YoEarthMarkerLocale.vue').default,
    YoEarthLoader: () => import('./YoEarthLoader.vue')
  },
  data () {
    return {
      earth: false,
      showPrivacy: false,
      Status,
      localeClusters: [],
      markers: [],
      newMe: {
        name: '',
        agree: false
      },
      msgs: []
    }
  },
  mounted () {
    window.onClickAvatarForPin = (raw) => {
      raw = unescape(raw)
      let jsonString = decodeURIComponent(raw)
      let data = JSON.parse(jsonString)
      console.log(data)
      window.dispatchEvent(new Event('closepop'))
      this.$emit('overlay', 'users')
      this.$emit('pinuser', data)
    }
    this.makeLocaleMarkers()
  },
  methods: {
    async makeLocaleMarkers () {
      this.localeClusters = []
      let people = []

      let pins = await eAPI.getPin({ earthID: this.earthID })

      pins.forEach(pin => {
        people.push({
          pos: {
            lat: pin.lat,
            lng: pin.lng,
            locale: pin.locale
          },
          person: {
            name: pin.name,
            avatar: pin.avatar.url
          }
        })
      })

      this.earth.panTo([pins[0].lat, pins[0].lng])

      // people.push({
      //   pos: {
      //     lat: 0.0,
      //     lng: 0.0,
      //     locale: `Hong Kong`
      //   },
      //   person: {
      //     name: `Lok Lok`,
      //     avatar: require('../img/user.svg')
      //   },
      //   open: true
      // })

      // people.push({
      //   pos: {
      //     lat: 0.0,
      //     lng: 0.0,
      //     locale: `Hong Kong`
      //   },
      //   person: {
      //     name: `Xiao Ming`,
      //     avatar: require('../img/user.svg')
      //   },
      //   open: false
      // })

      let cluster = _.groupBy(people, (item) => {
        return item.pos.locale
      })

      for (var key in cluster) {
        let culsterItems = cluster[key]
        this.localeClusters.push(culsterItems)
      }

      this.$forceUpdate()
    },
    run () {
      let WE = window.WE
      let MAP = WE.map
      var options = {
        atmosphere: true,
        center: [0, 0],
        zoom: 0,
        sky: true
      }
      var earth = new MAP('earth_div', options)
      this.earth = earth

      window.WE.tileLayer('http://tileserver.maptiler.com/nasa/{z}/{x}/{y}.jpg', {
        minZoom: 0,
        maxZoom: 6,
        attribution: 'NASA'
      }).addTo(earth)

      // var before = null
      // requestAnimationFrame(function animate (now) {
      //   var c = earth.getPosition()
      //   var elapsed = before ? now - before : 0
      //   before = now
      //   earth.setCenter([c[0], c[1] + 0.1 * (elapsed / 120)])
      //   requestAnimationFrame(animate)
      // })
    }
  }
}
</script>

<style scoped>
#earth_div{
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
}
.abspos{
  position: absolute;
  top: 0px;
  left: 0px;
  color: white;
  width: 100%;
  height: 100%;

  background-color: rgba(56, 56, 56, 0.596);
}

.all-center{
  text-align: center;
}

.privacy{
  white-space: pre-wrap;
}
.disclaimer{
  white-space: pre-wrap;
}
.red{
  color: red;
}

.linker{
  color: rgb(160, 177, 255);
  text-decoration: underline;
}
.marginer{
  margin: 0px auto;
  width: 500px;
  text-align: center;
}
</style>
